<div class="min-page-width-large-up">
    <lsq-banner [titleText]="title$ | async"></lsq-banner>

    <div class="container-fluid page-container">
        <div *ngIf="responsiveService.smBelow | async" class="mobile-settings-back-button-wrapper">
            <lsq-button
                appearance="transparent"
                class="mobile-settings-back-button"
                [routerLink]="mobileMenuRouterLink$ | async"
                routerLinkActive="hide"
                i18n="Go back to main settings menu"
            >
                Go Back
            </lsq-button>
        </div>
        <div class="d-flex flex-row">
            <div
                *ngIf="!(responsiveService.smBelow | async)"
                class="settings-navigation"
                role="navigation"
            >
                <ul class="list-unstyled">
                    <ng-container *ngFor="let navigationItem of navigationItems">
                        <ng-container *featureFlag="navigationItem.featureFlags">
                            <ng-container *environments="navigationItem.environments">
                                <li *claimsOr="navigationItem.claims">
                                    <a
                                        #routerLinkActive="routerLinkActive"
                                        routerLinkActive="active"
                                        [routerLink]="navigationItem.routerLink"
                                    >
                                        {{ navigationItem.label }}
                                        <span *ngIf="routerLinkActive.isActive" class="sr-only">
                                            (you are here)
                                        </span>
                                    </a>
                                </li>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ul>
            </div>

            <div class="settings-router-container">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>
